export function usingModal(nameModal, opacity, background) {
    var _a, _b, _c;
    if (!nameModal)
        nameModal = 'ModalLoading';
    var op = 0.8;
    if (opacity)
        op = opacity;
    var bg = "rgba(111, 111, 111, " + op + ")";
    if (background)
        bg = background;
    (_a = document.getElementById(nameModal)) === null || _a === void 0 ? void 0 : _a.style.setProperty("display", "block");
    (_b = document.getElementById(nameModal)) === null || _b === void 0 ? void 0 : _b.style.setProperty("background", bg);
    (_c = document.getElementById(nameModal)) === null || _c === void 0 ? void 0 : _c.classList.add("show");
}
export function closeModal(nameModal) {
    var _a, _b;
    if (!nameModal)
        nameModal = 'ModalLoading';
    (_a = document.getElementById(nameModal)) === null || _a === void 0 ? void 0 : _a.style.setProperty("display", "none");
    (_b = document.getElementById(nameModal)) === null || _b === void 0 ? void 0 : _b.classList.remove("show");
}
